export default __webpack_public_path__ + "static/media/img5.7c2e0ac4.png";